import ButtonWithSpinner from 'components/common/ButtonWithSpinner';
import IconComponent from 'components/common/IconComponent';
import { useChatRoomData } from 'hooks/useMessagesRelatedProps';
import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router';
import ROUTES from 'routes/routeConstants';

import TransactionTabs from './components/TransactionTabs';
import { useTransactionRelatedProps } from './hooks';

export const transactionGeneralStyle = {
  padding: 16,
};

const Transaction: React.FC = () => {
  const history = useHistory();
  const TransactionTitle = useCallback(
    () => (
      <div className='p-2 border-b border-border_color'>
        <ButtonWithSpinner
          buttonType='text'
          onClick={() => {
            if (history.action !== 'POP') {
              history.goBack();
            } else {
              history.push(ROUTES.TRANSACTIONS);
            }
          }}
          className='!m-0 !p-0'
          height='auto'
          width='auto'>
          <div className='flex items-center'>
            <IconComponent name='chevron-left' size={20} />
            <div className='ml-3 text-lg'>Back</div>
          </div>
        </ButtonWithSpinner>
      </div>
    ),
    [],
  );

  const transactionProps = useTransactionRelatedProps();
  const { subscribeToMessagesForUpdateChatRoom, ...chatRoomProps } = useChatRoomData({
    transactionId: transactionProps.transactionId,
  });

  useEffect(() => {
    const unsubMessage = subscribeToMessagesForUpdateChatRoom();
    return () => {
      unsubMessage();
    };
  }, []);

  return (
    <div className='flex flex-col h-full max-h-full overflow-hidden'>
      <TransactionTitle />
      <div className='flex-1 flex items-stretch overflow-hidden'>
        <TransactionTabs {...transactionProps} {...chatRoomProps} />
      </div>
    </div>
  );
};

export default React.memo(Transaction);
